import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function isSubmittingRequest(state = initialState.isSubmitting, action) {
  if (action.type === types.SUBMITTING_REQUEST_STATUS) {
    return action.isSubmitting;
  }
  return state;
}
